import axiosClient from './axiosClient';
import { compressImage } from '../utils/imageCompression';

export const getClasses = (params?: Record<string, any>) => {
    return axiosClient.get('/classes', { params });
};

export const getClassDetail = (id: string) => {
    return axiosClient.get(`/classes/${id}`);
};

export const createClass = (data: Record<string, any>) => {
    return axiosClient.post('/classes', data);
};

export const updateClass = (id: string, data: Record<string, any>) => {
    return axiosClient.put(`/classes/${id}`, data);
};

export const deleteClass = (id: string) => {
    return axiosClient.delete(`/classes/${id}`);
};

export const uploadClassBanner = async (id: string, file: File) => {
    const compressed = await compressImage(file, {
        maxSizeMB: 0.8,
        maxWidthOrHeight: 1280,
    });
    const formData = new FormData();
    formData.append('file', compressed);
    return axiosClient.post(`/classes/${id}/banner`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const uploadClassLogo = async (id: string, file: File) => {
    const compressed = await compressImage(file, {
        maxSizeMB: 0.3,
        maxWidthOrHeight: 500,
    });
    const formData = new FormData();
    formData.append('file', compressed);
    return axiosClient.post(`/classes/${id}/logo`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const addStudentToClass = (classId: string, studentId: string) => {
    return axiosClient.post(`/classes/${classId}/students/${studentId}`);
};

export const addStudentsToClassBatch = (classId: string, studentIds: string[]) => {
    return axiosClient.post(`/classes/${classId}/students/batch`, { student_ids: studentIds });
};

export const getEligibleStudentsForClass = (classId: string, params?: { search?: string; limit?: number }) => {
    return axiosClient.get(`/classes/${classId}/eligible-students`, { params });
};

export const removeStudentFromClass = (classId: string, studentId: string) => {
    return axiosClient.delete(`/classes/${classId}/students/${studentId}`);
};

export const updateStudentClassRole = (classId: string, studentId: string, role: string) => {
    return axiosClient.put(`/classes/${classId}/students/${studentId}/role`, { role });
};

export const getClassTimetable = (classId: string) => {
    return axiosClient.get(`/classes/${classId}/timetable`);
};

export const updateClassTimetable = (classId: string, data: Record<string, any>) => {
    return axiosClient.put(`/classes/${classId}/timetable`, data);
};

export const getPublicClassPreview = (classId: string) => {
    return axiosClient.get(`/classes/${classId}/public`);
};

export const getClassShares = (classId: string) => {
    return axiosClient.get(`/classes/${classId}/shares`);
};

export const createClassShare = (classId: string, data: { user_id: string; role: string; note?: string }) => {
    return axiosClient.post(`/classes/${classId}/shares`, data);
};

export const updateClassShare = (classId: string, shareId: string, data: { role?: string; note?: string }) => {
    return axiosClient.put(`/classes/${classId}/shares/${shareId}`, data);
};

export const deleteClassShare = (classId: string, shareId: string) => {
    return axiosClient.delete(`/classes/${classId}/shares/${shareId}`);
};

export const getEligibleUsersForShare = (classId: string, params?: { search?: string }) => {
    return axiosClient.get(`/classes/${classId}/eligible-users`, { params });
};

export const downloadClassStudentImportTemplate = () => {
    return axiosClient.get('/classes/import-template', {
        responseType: 'blob'
    });
};

export const importClassStudentsExcel = (classId: string, formData: FormData) => {
    return axiosClient.post(`/classes/${classId}/import-students`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};


